import { useCallback, useEffect, useState } from "react";
import type {
  PayrollStatementNotificationDelivery,
  PayrollStatementNotificationRecipient,
  SubmittedPayrollStatementNote,
} from "./types";
import {
  reconcileSubmittedNoteDrafts,
  trackSubmittedNoteDrafts,
} from "./utils";

export const usePayrollStatementNoteDrafts = (
  recipients: PayrollStatementNotificationRecipient[],
) => {
  const [noteDrafts, setNoteDrafts] = useState<Record<string, string>>({});
  const [submittedNotes, setSubmittedNotes] = useState<
    Record<string, SubmittedPayrollStatementNote>
  >({});

  useEffect(() => {
    const reconciled = reconcileSubmittedNoteDrafts({
      noteDrafts,
      submittedNotes,
      recipients,
    });

    if (reconciled.noteDrafts !== noteDrafts) {
      setNoteDrafts(reconciled.noteDrafts);
    }
    if (reconciled.submittedNotes !== submittedNotes) {
      setSubmittedNotes(reconciled.submittedNotes);
    }
  }, [noteDrafts, recipients, submittedNotes]);

  const setNoteDraft = useCallback((technicianId: string, note: string) => {
    setNoteDrafts((current) => ({ ...current, [technicianId]: note }));
  }, []);

  const trackSubmittedNotes = useCallback(
    (deliveries: PayrollStatementNotificationDelivery[]) => {
      setSubmittedNotes((current) =>
        trackSubmittedNoteDrafts({
          submittedNotes: current,
          deliveries,
          noteDrafts,
        }),
      );
    },
    [noteDrafts],
  );

  return { noteDrafts, setNoteDraft, trackSubmittedNotes };
};
